<template>
  <GChart
    :settings="{packages: ['corechart']}"
    :version="'42'"
    :createChart="createChart"
  />
</template>

<script>
import { GChart } from 'vue-google-charts'
// eslint-disable-next-line no-unused-vars
import PieChart from '../features/reports/common/PieChart'

/**
 * Base Pie Chart component for RankZone tabs used in {@link PieChart}
 */
export const allColors = [
  '#264653', '#287271', '#2A9D8F', '#8AB17D',
  '#E9C46A', '#F4A261', '#F3B090', '#E76F51',
  '#E4596F', '#FF83B0', '#C26CED', '#866CED',
  '#4B80CD', '#5CAAD5', '#4a869F'
]

export default {
  name: 'BasePieChart',
  components: {
    GChart
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    allColors: {
      type: [Array, Boolean],
      default: false
    }
  },
  data () {
    return {
      chartData: this.prepareDateByType(),
      google: null,
      el: null
    }
  },
  watch: {
    allColors: {
      handler () {
        const value = this.prepareDateByType()
        this.chartData = { data: value.data, colorSchema: value.colorSchema }
        this.createChart(this.el, this.google)
      },
      deep: true
    },
    list () {
      const value = this.prepareDateByType()
      this.chartData = { data: value.data, colorSchema: value.colorSchema }
      this.createChart(this.el, this.google)
    }
  },
  methods: {
    /**
     * Preparing chart data  according to
     * {@link https://developers.google.com/chart/interactive/docs/datatables_dataviews#arraytodatatable}
     * @returns {data:  {data: array of chart data, colorSchema: array of colors} }
     */
    prepareDateByType () {
      const header = [ 'Company', 'Value' ]
      const result = []
      this.list.forEach(item => result.push([ item.name, item.value ]))
      result.unshift(header)
      return {
        data: result,
        colorSchema: (this.allColors || allColors).slice(0, result.length)
      }
    },
    /**
     * Callback for createChart property of vue-google-charts library
     * all list of available options {@see https://developers.google.com/chart/interactive/docs/gallery/piechart#configuration-options}
     * prepared data passed into chat using DataView {@link https://developers.google.com/chart/interactive/docs/datatables_dataviews}
     * @param el - chart html element
     * @param google - link to the Google Chart library
     */
    createChart (el, google) {
      if (!this.google) {
        this.google = google
        this.el = el
      }
      const data = google.visualization.arrayToDataTable(this.chartData.data)
      const view = new google.visualization.DataView(data)
      const options = {
        colors: this.chartData.colorSchema,
        legend: 'none',
        backgroundColor: 'transparent',
        title: 'none',
        axisFontSize: 0,
        chartArea: { width: '90%', height: '90%', left: 8, top: 8 },
        pieHole: 0.4,
        label: 'none',
        height: 200,
        width: 200,
        pieSliceText: 'none',
        tooltip: { trigger: 'focus' },
        hAxis: {
          viewWindowMode: 'maximized',
          gridlines: {
            count: 0,
            color: 'transparent'
          },
          scaleType: 'log',
          textPosition: 'none',
          baselineColor: 'transparent'
        },
        vAxis: {
          gridlines: {
            color: 'transparent'
          },
          scaleType: 'log',
          textPosition: 'none',
          baselineColor: 'transparent'
        }
      }

      try {
        let chart = new google.visualization.PieChart(el)
        chart.draw(view, options)
        /* to prevent unexpected interaction by click on chart */
        google.visualization.events.addListener(chart, 'select', () => {
          chart.setSelection(null)
        })
        /* to prevent show errors on chart */
        google.visualization.events.addListener(chart, 'error', function (err) {
          console.log('error', err)
        })
      } catch (e) {
        console.log(e, el)
      }
    }
  }
}

</script>

<style scoped lang="scss">

</style>
